import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute/PrivateRoute.jsx";


import "assets/css/material-dashboard-react.css?v=1.5.0";

import indexRoutes from "routes/index.jsx";
import AppProvider from 'providers/App/AppProvider.jsx';

const hist = createBrowserHistory();

ReactDOM.render(
  <AppProvider>
    <Router history={hist}>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return <PrivateRoute path={prop.path} component={prop.component} key={key} />;
        })}
      </Switch>
    </Router>
  </AppProvider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js